export default "__VITE_ASSET__aRwiZoeL__"